import styled from "styled-components";

export const Nav = styled.nav`
  width: calc(100vw - 320px);
  background: #fff;
  border-bottom: 1px solid var(--gray-light);
  padding: 0px 160px;

  @media (max-width: 960px) {
    width: calc(100vw - 40px);
    padding: 0px 20px;
  }

  @media (max-width: 720px) {
    display: none;
  }
`;

export const NavList = styled.ul`
  display: flex;
  flex: 1;
  flex-direction: row;
  list-style-type: none;
  justify-content: space-around;
  margin: 0;
  padding: 0;
`;

export const NavListItem = styled.li<{ isActive?: boolean }>`
  position: relative;
  display: flex;
  gap: 8px;
  align-items: center;
  color: ${props => props.isActive ? 'var(--primary)' : 'var(--neutral)'};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  padding: 20px 12px;
  cursor: pointer;
  transition: color 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--primary);
    opacity: ${props => props.isActive ? 1 : 0};
    transition: opacity 0.2s ease;
  }

  &:hover {
    color: var(--primary);

    &::after {
      opacity: 1;
    }
  }

  img {
    width: 12px;
    height: 12px;
    transition: transform 0.2s ease;
    ${props => props.isActive && `transform: rotate(180deg);`}
  }
`;

export const NavListSubMenu = styled.ul`
  position: absolute;
  background: #fff;
  border-radius: 4px;
  padding: 8px 0;
  min-width: 220px;
  top: 100%;
  left: 0;
  border: 1px solid var(--gray-light);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  list-style: none;
  margin: 0;
  margin-top: 0;
`;

export const SubMenuItem = styled.li`
  display: flex;
  align-items: center;
  color: var(--neutral);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding: 12px 20px;
  transition: all 0.15s ease;
  cursor: pointer;

  &:hover {
    background: var(--gray-lightest);
    color: var(--primary);
  }
`;
